import React from 'react';
import Link from 'next/link';

interface ButtonProps {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean; // Add the disabled prop

  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({ href, onClick, children, className = '', type = 'button' }) => {
  const baseClasses =
    'bg-orange-500 text-white text-sm px-8 py-3 rounded-lg border-2 border-orange-600 hover:bg-orange-600 cursor-pointer';

  if (href) {
    return (
      <Link href={href} className={`${baseClasses} ${className}`}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={`${baseClasses} ${className}`}>
      {children}
    </button>
  );
};

export default Button;